const slider_config_type = {
  1: {
    slidesPerView: 4,
    spaceBetween: 20,
    breakpoints: {
      1: {
        slidesPerView: 2,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        spaceBetween: 10,
      },
      300: {
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        slidesPerView: 1.2,
        spaceBetween: 10,
      },
      500: {
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1023: {
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        slidesPerView: 4,
        spaceBetween: 20
      },
    }
  },
  2: {
    slidesPerView: "auto",
    spaceBetween: 64,
    loop: true,
    speed: 5000,
    watchOverflow: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
  },
  3: {
    slidesPerView:6,
    spaceBetween: 20,
    breakpoints: {
      1: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      300: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      500: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
      1023: {
        slidesPerView: 6,
        spaceBetween: 20
      },
    }
  },
  4: {
    slidesPerView:1,
    spaceBetween: 20
  },
  6: {
    slidesPerView: "auto",
    spaceBetween: 16,
    watchOverflow: true,
    breakpoints: {
      990: {
        spaceBetween: 32,
      },
    },
  },
  5: {
    slidesPerView:4,
    spaceBetween: 20,
    breakpoints: {
      1: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      300: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      500: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1023: {
        slidesPerView: 4,
        spaceBetween: 20
      },
    }
  },
   
};

class CustomSlider extends HTMLElement {
  connectedCallback() {
    this.index = this.dataset.index || 1;

    const section = this.closest('.shopify-section');

    const nextEl = this.querySelector(".swiper-button-next") || section?.querySelector(".swiper-button-next");
    const prevEl = this.querySelector(".swiper-button-prev") || section?.querySelector(".swiper-button-prev");
    const paginationEl = this.querySelector(".swiper-pagination") || section?.querySelector(".swiper-pagination");

    this.navigation = nextEl && prevEl
      ? {
          navigation: {
            nextEl,
            prevEl,
          },
        }
      : {};

    this.pagination = paginationEl
      ? {
          pagination: {
            el: paginationEl,
            clickable: true,
          },
        }
      : {};

    this.config = {
      ...slider_config_type[this.index],
      ...this.navigation,
      ...this.pagination,
      observer: true,
      observeParents: true,
    };

    this.swiper = new Swiper(this, this.config);
  }
}

customElements.define('custom-slider', CustomSlider);